import { environment } from 'src/environments/environment';

export const serverUrl = environment.apiUrl + 'v1/';

export const CHANGE_PASSWORD = 'UserAccount/changePassword';

export const Account_URL = {
    CHANGE_PASSWORD: serverUrl + CHANGE_PASSWORD
};
